'use client';

// npm packages
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';

// components
import { useDispatch } from 'react-redux';
import { setIsLogoutPopupShow } from '@/redux/reducers/auth-reducer';
import { logoutOtp } from '@/redux/thunk/auth-thunk';
import { REDIRECT_AFTER_LOGOUT } from '@/constants';
import Text from '../Text';
import Icon from '../Icon';
import Button from '../Button';

// utils

function LogoutConfirmModal({ onView, onClose }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(onView);
  const pathname = usePathname();

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 200);
  };

  const handleLogout = async () => {
    dispatch(logoutOtp());
    handleClose();
    dispatch(setIsLogoutPopupShow(true));
    const shouldRedirect = REDIRECT_AFTER_LOGOUT.some((route) =>
      pathname.includes(route),
    );
    if (shouldRedirect) {
      router.push('/');
    } else {
      // window.location.reload();
    }
  };

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  return (
    <>
      <div
        className={classNames(
          'w-full h-full bg-black/30 flex justify-center items-center opacity-30 transition-all duration-100 fixed top-full left-0 right-0',
          {
            '!top-0 !opacity-100 !z-[501]': openModal,
          },
        )}
      >
        <div
          className={classNames(
            `w-full flex items-center justify-center mx-8 rounded-[4px] sm:rounded-[12px] transition-all duration-[400ms]`,
            // { "!bottom-0 !opacity-100": openModal }
          )}
        >
          <div className="max-w-[480px] relative">
            <div className="mb-12">
              <Icon
                type="close"
                color="#fff"
                onClick={handleClose}
                className="cursor-pointer ml-auto"
              />
            </div>
            <div className="bg-white p-24 rounded-xl shadow-cannot-be-added-modal">
              <Text
                type="sub_title"
                className="!font-encode-sans !text-20 font-semibold text-center text-fire-chalk leading-28 tracking-[0.4px] mb-16"
              >
                Log out
              </Text>
              <Text
                type="sub_title"
                className="text-chokecherry text-center text-18 sm:text-20 font-encode-sans font-semibold leading-28 tracking-[0.36px] sm:tracking-[0.4px] mb-20"
              >
                {/* <span className="hidden sm:block"> Do you want to logout?</span> */}
                <span className="text-coarse-wool">
                  Are you sure you want to log out?
                </span>
              </Text>
              <div className="flex gap-[16px]">
                <Button
                  type="primary"
                  className="w-1/2 sm:min-w-[190px] !bg-white border !border-pacific-queen !py-8 !px-16 line-clamp-1"
                  onClick={handleClose}
                >
                  <Text
                    type="paragraph"
                    className="!text-pacific-queen text-center text-14 font-encode-sans !font-semibold leading-20 tracking-[0.28px]"
                  >
                    Cancel
                  </Text>
                </Button>
                <Button
                  type="primary"
                  className="w-1/2 sm:min-w-[190px] !bg-pacific-queen border !border-pacific-queen !py-8 !px-16 line-clamp-1"
                  onClick={() => handleLogout()}
                >
                  <Text
                    type="paragraph"
                    className="text-white text-center text-14 font-encode-sans !font-semibold leading-20 tracking-[0.28px]"
                  >
                    {/* <span className="">No</span> */}
                    Log Out
                  </Text>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal
        type="logout-successful-modal"
        onView={isOpenLogoutSuccessfulModal}
        onClose={handleCloseLogoutSuccessfulModal}
      /> */}
    </>
  );
}

export default LogoutConfirmModal;
